document.addEventListener('click', (e) => {
  const btn = e.target.closest('.js-scroll-top, [data-scroll-top]');
  if (!btn) return;
  e.preventDefault();
  window.scrollTo({ top: 0, behavior: 'smooth' });
});

document.addEventListener('click', (e) => {
  const slide = e.target.closest('.slideshow__slide--has-link[data-slide-link]');
  if (!slide) return;
  if (e.target.closest('a, button')) return;
  const url = slide.dataset.slideLink;
  if (url) window.location.href = url;
});

(function inlineCartAdd() {
  const WIDGET = '[data-inline-add]';

  function itemsMap(items) {
    const map = {};
    (items || []).forEach((item) => {
      map[item.variant_id] = (map[item.variant_id] || 0) + item.quantity;
    });
    return map;
  }

  function selectedRadio(widget) {
    return (
      widget.querySelector('.card-variant-radio:checked') || widget.querySelector('.card-variant-radio')
    );
  }

  function reconcileWidget(widget) {
    const radio = selectedRadio(widget);
    if (!radio) return;

    const variantId = radio.dataset.variantId;
    const qty = parseInt(radio.dataset.variantQty || '0', 10);
    const available = radio.dataset.variantAvailable === 'true';

    const idInput = widget.querySelector('.product-variant-id');
    if (idInput) {
      idInput.value = variantId;
      idInput.disabled = !available;
    }

    const addBtn = widget.querySelector('[data-add-btn]');
    const stepper = widget.querySelector('[data-stepper]');
    const qtyEl = stepper && stepper.querySelector('[data-qty]');

    if (qty > 0) {
      widget.classList.add('is-in-cart');
      if (qtyEl) qtyEl.textContent = qty;
      if (addBtn) addBtn.setAttribute('tabindex', '-1');
    } else {
      widget.classList.remove('is-in-cart');
      if (addBtn) addBtn.removeAttribute('tabindex');
    }

    if (addBtn) {
      addBtn.disabled = !available;
      const label = addBtn.querySelector('span:not(.sold-out-message)');
      const soldOut = addBtn.querySelector('.sold-out-message');
      if (available) {
        if (label) label.classList.remove('hidden');
        if (soldOut) soldOut.classList.add('hidden');
      } else {
        if (label) label.classList.add('hidden');
        if (soldOut) soldOut.classList.remove('hidden');
      }
    }
  }

  function reconcileAll(map) {
    document.querySelectorAll(WIDGET).forEach((widget) => {
      widget.querySelectorAll('.card-variant-radio').forEach((radio) => {
        if (radio.dataset.variantId) radio.dataset.variantQty = map[radio.dataset.variantId] || 0;
      });
      reconcileWidget(widget);
    });
  }

  function updateBubble(sections) {
    const html = sections && sections['cart-icon-bubble'];
    const el = document.getElementById('cart-icon-bubble');
    if (!html || !el) return;
    const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (parsed) el.innerHTML = parsed.innerHTML;
  }

  function refetchAndReconcile() {
    fetch(`${window.routes.cart_url}.js`)
      .then((r) => r.json())
      .then((cart) => reconcileAll(itemsMap(cart.items)))
      .catch(() => {});
  }

  function openCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function' && !drawer.classList.contains('active')) {
      drawer.open();
    }
  }

  function changeQty(widget, variantId, quantity, shouldOpen) {
    if (widget.dataset.loading === 'true') return;
    widget.dataset.loading = 'true';
    const stepper = widget.querySelector('[data-stepper]');
    if (stepper) stepper.classList.add('card-stepper--loading');

    const body = JSON.stringify({
      id: variantId,
      quantity: quantity,
      sections: ['cart-icon-bubble'],
      sections_url: window.location.pathname,
    });

    fetch(`${window.routes.cart_change_url}`, { ...fetchConfig(), body })
      .then((r) => r.json())
      .then((cart) => {
        if (cart.status) {
          refetchAndReconcile();
          return;
        }
        updateBubble(cart.sections);
        reconcileAll(itemsMap(cart.items));

        const published =
          typeof publish === 'function'
            ? publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'card-product-inline',
                cartData: cart,
                variantId: variantId,
              })
            : Promise.resolve();

        if (shouldOpen) published.then(openCartDrawer);
      })
      .catch(() => refetchAndReconcile())
      .finally(() => {
        widget.dataset.loading = 'false';
        if (stepper) stepper.classList.remove('card-stepper--loading');
      });
  }

  document.addEventListener('change', (e) => {
    const radio = e.target.closest('.card-variant-radio');
    if (!radio) return;
    const widget = radio.closest(WIDGET);
    if (widget) reconcileWidget(widget);
  });

  document.addEventListener('click', (e) => {
    const stepBtn = e.target.closest('[data-step]');
    if (!stepBtn) return;
    const widget = stepBtn.closest(WIDGET);
    if (!widget) return;
    const radio = selectedRadio(widget);
    if (!radio) return;
    const isPlus = stepBtn.dataset.step === 'plus';
    const current = parseInt(radio.dataset.variantQty || '0', 10);
    const next = isPlus ? current + 1 : current - 1;
    if (next < 0) return;
    changeQty(widget, radio.dataset.variantId, next, isPlus);
  });

  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
      if (data && data.source === 'card-product-inline') return;
      const items = data && data.cartData && data.cartData.items;
      if (items) reconcileAll(itemsMap(items));
      else refetchAndReconcile();
    });
  }
})();

(function variantSlider() {
  const TRACK = '.card-variant-track';

  function updateEdges(track) {
    const max = track.scrollWidth - track.clientWidth;
    const scrollable = max > 1;
    const x = track.scrollLeft;
    track.classList.toggle('pf-can-scroll', scrollable);
    track.classList.toggle('pf-fade-left', scrollable && x > 1);
    track.classList.toggle('pf-fade-right', scrollable && x < max - 1);
  }

  const resizeObserver =
    'ResizeObserver' in window
      ? new ResizeObserver((entries) => entries.forEach((entry) => updateEdges(entry.target)))
      : null;

  function initTrack(track) {
    if (track.dataset.pfSlider === 'true') return;
    track.dataset.pfSlider = 'true';

    updateEdges(track);
    if (resizeObserver) resizeObserver.observe(track);
    track.addEventListener('scroll', () => updateEdges(track), { passive: true });

    track.addEventListener(
      'wheel',
      (e) => {
        const max = track.scrollWidth - track.clientWidth;
        if (max <= 1 || Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        const atStart = track.scrollLeft <= 0;
        const atEnd = track.scrollLeft >= max - 1;
        if ((e.deltaY < 0 && atStart) || (e.deltaY > 0 && atEnd)) return;
        e.preventDefault();
        track.scrollLeft += e.deltaY;
      },
      { passive: false }
    );

    let down = false;
    let moved = false;
    let startX = 0;
    let startLeft = 0;

    track.addEventListener('pointerdown', (e) => {
      moved = false;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (track.scrollWidth - track.clientWidth <= 1) return;
      down = true;
      startX = e.clientX;
      startLeft = track.scrollLeft;
    });

    track.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 4) {
        moved = true;
        track.classList.add('pf-dragging');
        try {
          track.setPointerCapture(e.pointerId);
        } catch (err) {}
      }
      if (moved) track.scrollLeft = startLeft - dx;
    });

    const endDrag = () => {
      down = false;
      track.classList.remove('pf-dragging');
    };
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    track.addEventListener(
      'click',
      (e) => {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      },
      true
    );
  }

  function initAll(root) {
    (root || document).querySelectorAll(TRACK).forEach(initTrack);
  }

  function refreshAll() {
    document.querySelectorAll(TRACK).forEach(updateEdges);
  }

  initAll();
  document.addEventListener('DOMContentLoaded', () => initAll());
  window.addEventListener('load', refreshAll);
  window.addEventListener('resize', refreshAll);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(refreshAll);
  }

  if ('MutationObserver' in window) {
    let debounce;
    new MutationObserver(() => {
      clearTimeout(debounce);
      debounce = setTimeout(() => initAll(), 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  }
})();

if ('IntersectionObserver' in window) {
  const videoObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach(({ isIntersecting, target }) => {
        isIntersecting ? target.play().catch(() => {}) : target.pause();
      });
    },
    { threshold: 0.25 }
  );

  document.querySelectorAll('video.js-autoplay-video').forEach((video) => {
    videoObserver.observe(video);
  });

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      document.querySelectorAll('video.js-autoplay-video').forEach((video) => {
        videoObserver.observe(video);
      });
    });
  }
}

(function megaMenuHover() {
  function closeMenu(menu) {
    const details = menu.querySelector('details');
    if (!details || !details.open) return;
    details.open = false;
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }

  function initAll() {
    const header = document.querySelector('header[data-menu-hover="true"]');
    if (!header) return;
    if (window.matchMedia('(hover: none)').matches) return;

    const menus = Array.prototype.slice.call(header.querySelectorAll('header-menu'));

    menus.forEach((menu) => {
      if (menu.dataset.pfHover === 'true') return;
      const details = menu.querySelector('details');
      const summary = details && details.querySelector('summary');
      if (!details || !summary) return;
      menu.dataset.pfHover = 'true';

      menu.addEventListener('mouseenter', () => {
        clearTimeout(menu.pfCloseTimer);
        menus.forEach((other) => {
          if (other !== menu) closeMenu(other);
        });
        if (!details.open) {
          details.open = true;
          summary.setAttribute('aria-expanded', 'true');
        }
      });

      menu.addEventListener('mouseleave', () => {
        menu.pfCloseTimer = setTimeout(() => closeMenu(menu), 150);
      });

      summary.addEventListener('click', (e) => {
        if (e.detail !== 0) e.preventDefault();
      });
    });
  }

  initAll();
  document.addEventListener('DOMContentLoaded', initAll);

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAll);
  }
})();

(function footerAccordion() {
  const mq = window.matchMedia('(max-width: 749px)');

  function sync() {
    const collapse = mq.matches;
    document.querySelectorAll('details[data-footer-collapsible]').forEach((details) => {
      details.open = !collapse;
    });
  }

  sync();
  document.addEventListener('DOMContentLoaded', sync);

  if (mq.addEventListener) {
    mq.addEventListener('change', sync);
  } else if (mq.addListener) {
    mq.addListener(sync);
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', sync);
  }
})();

(function setupLiveRegion() {
  if (document.getElementById('pf-a11y-announcer')) return;
  const announcer = document.createElement('div');
  announcer.id = 'pf-a11y-announcer';
  announcer.setAttribute('aria-live', 'polite');
  announcer.setAttribute('aria-atomic', 'true');
  Object.assign(announcer.style, {
    position: 'absolute',
    width: '1px',
    height: '1px',
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    whiteSpace: 'nowrap',
  });
  document.body.appendChild(announcer);

  window.announceToScreenReader = (message) => {
    announcer.textContent = '';
    requestAnimationFrame(() => {
      announcer.textContent = message;
    });
  };
})();

(function richTextCollapsibleSubtitles() {
  const SELECTOR = '[data-rich-text-collapsible]:not([data-rich-text-collapsible-ready])';

  function isSubtitle(el) {
    return (
      el.tagName === 'P' &&
      el.children.length === 1 &&
      el.children[0].tagName === 'STRONG' &&
      el.textContent.trim() === el.children[0].textContent.trim() &&
      el.textContent.trim() !== ''
    );
  }

  function build(container) {
    const children = Array.from(container.children);
    let i = 0;

    while (i < children.length) {
      const heading = children[i];

      if (!isSubtitle(heading)) {
        i++;
        continue;
      }

      const body = [];
      let j = i + 1;
      while (j < children.length && !isSubtitle(children[j])) {
        body.push(children[j]);
        j++;
      }

      if (body.length) {
        const details = document.createElement('details');
        details.className = 'rich-text__collapsible';

        const summary = document.createElement('summary');
        summary.className = 'rich-text__collapsible-summary';
        summary.innerHTML = heading.innerHTML;

        details.appendChild(summary);
        body.forEach((node) => details.appendChild(node));
        container.replaceChild(details, heading);
      }

      i = j;
    }
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach((container) => {
      container.setAttribute('data-rich-text-collapsible-ready', '');
      build(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
